import ViewsPage from './viewsPage.view';

export default ViewsPage;
